document.addEventListener("DOMContentLoaded", function () {
  const countdownContainer = document.getElementById("top-bar-countdown");
  const countdownDisplay = document.getElementById("countdown");

  if (!countdownContainer || !countdownDisplay) return;

  const countdownHours = parseInt(countdownContainer.getAttribute("data-hours")) || 0;
  const countdownMinutes = parseInt(countdownContainer.getAttribute("data-minutes")) || 0;
  const countdownSeconds = parseInt(countdownContainer.getAttribute("data-seconds")) || 0;

  const countdownVersion = `${countdownHours}-${countdownMinutes}-${countdownSeconds}`;
  const storageKeyTime = "topBarCountdownEndTime";
  const storageKeyVersion = "topBarCountdownVersion";

  let targetTime = localStorage.getItem(storageKeyTime);
  const savedVersion = localStorage.getItem(storageKeyVersion);

  if (savedVersion !== countdownVersion || !targetTime) {
    const totalSeconds =
      (countdownHours * 3600) +
      (countdownMinutes * 60) +
      countdownSeconds;

    targetTime = Date.now() + totalSeconds * 1000;
    localStorage.setItem(storageKeyTime, targetTime);
    localStorage.setItem(storageKeyVersion, countdownVersion);
  } else {
    targetTime = parseInt(targetTime, 10);
  }

  function pad(n) {
    return n < 10 ? '0' + n : n;
  }

  function updateCountdown() {
    const now = Date.now();
    let distance = targetTime - now;

    if (distance <= 0) {
      const resetDuration =
        (countdownHours * 3600 +
         countdownMinutes * 60 +
         countdownSeconds) * 1000;

      targetTime = Date.now() + resetDuration;
      localStorage.setItem(storageKeyTime, targetTime);
      distance = resetDuration;
    }

    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    countdownDisplay.innerText = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
});
